import { Typography, Link } from '@mui/material';

/**
 * @name MobileNavList
 * @description Display dropdown in mobile device
 * @param {object} root0  - destructured object
 * @param {object} root0.nav - Data from Strapi
 * @param {Function} root0.handleExpand - Function for expanding nav list
 * @returns {JSX.Element} ReactJs Element
 */
const MobileNavList = ({ nav, handleExpand }) =>
  nav?.map(level3 =>
    level3?.Link?.map((data, i) => (
      <Link
        href={data?.link}
        key={i}
        passHref
        underline='none'
        onClick={handleExpand}
        aria-label={data?.ariaLabel}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleExpand();
            e.currentTarget.click();
          }
        }}
        sx={{ color: 'inherit' }}
      >
        <Typography variant='body1' sx={{ p: 1 }} onClick={handleExpand}>
          {data?.title}
        </Typography>
      </Link>
    )));

MobileNavList.displayName = 'MobileNavList';
export default MobileNavList;
